Peer = require('./peer')
class RemoteDesktopSession
  resize=1
  validIdleTime = 1000 * 60 * 5
  idleTimer = undefined
  constructor: (@element, socket, device, disconnect, @$timeout)->
    iceServers = undefined
    remoteDesktopElement = document.querySelector('.remote-desktop')
    @remoteDesktopScope = angular.element(remoteDesktopElement).scope();
    opt={
      id : device._id
      resize : device.resize
    }
    resize = device.resize
    console.log opt
    socket.on 'twilio:webrtc', (config)=>
      @iceServers = config
    socket.emit "init wrtc", opt, (err, msg)=>
      console.log msg
      console.log err
      @peer = new Peer(socket, @iceServers);
      @peer.on 'connection', (conn) =>
        console.log 'connection come'
        @conn = conn
        @init()
      @peer.on 'stream', (stream)=>
        console.log 'stream come'
        @stream = stream
        @element.get(0).srcObject = stream
        @element.attr "loading", false
        @element.focus()
      # console.log @peer
      @peer.connect()
  init: ()->
    @resetIdleTimer()
    @listen 'loadedmetadata', (e) =>
      @resetIdleTimer()
      console.log 'loaded'
      @element.get(0).muted = true;
      @element.get(0).play()

    @listen 'keydown', (e)=>
      @resetIdleTimer()
      e.preventDefault();
      movement =
        "type": "keydown"
        "key": e.key
      console.log movement
      @send movement

    @listen 'keyup', (e)=>
      @resetIdleTimer()
      e.preventDefault();
      movement =
        "type": "keyup"
        "key": e.key
      console.log movement
      @send movement


    @listen 'mousemove', (e)=>
      @resetIdleTimer()
      console.log resize
      console.log @element.width()
      console.log @element.height()
      movement =
        "type": "mousemove"
        "x":Math.round(e.offsetX/resize)
        "y":Math.round(e.offsetY/resize)
      console.log movement
      @send movement

    @listen 'contextmenu', (e)=>
      @resetIdleTimer()
      console.log 'detect right click and disable menu'
      return false
    @listen 'mousedown', (e)=>
      @resetIdleTimer()
      movement =
        "type": "mousedown"
        "which": e.which
      console.log movement
      @send movement

    @listen 'mouseup', (e)=>
      @resetIdleTimer()
      movement =
        "type": "mouseup"
        "which": e.which
      console.log movement
      @send movement

  listen: (event, handler)->
    console.log 'listen'
    @remoteDesktopScope.disconnect = false
    @element.off(event).on event, handler
  send: (data)->

    console.log @conn.readyState
    @conn.send JSON.stringify(data)
  
  resetIdleTimer: ()=>
    if idleTimer
      @$timeout.cancel idleTimer
    idleTimer = @$timeout ()=>
      @peer.close()
      @remoteDesktopScope.disconnect = true
    , validIdleTime

module.exports = RemoteDesktopSession


// WEBPACK FOOTER //
// ./src/component/device/remote/directive/session.coffee